import { createSlice, createSelector } from '@reduxjs/toolkit';
import { decodeToken } from 'react-jwt';
import { setSession } from '../../guards/jwt/Jwt';

const initialState = { 
  isAuthenticated: false, 
  user: null,
  token: null,
  company: null,
  loading: false,
  error: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state) => {
      const accessToken = localStorage.getItem('accessToken');
      
      if (!accessToken) {
        setSession(null);
        return initialState;
      }

      try {
        const decodedToken = decodeToken(accessToken);
        
        if (!decodedToken?.MobileAssistanceUserId) {
          setSession(null);
          return initialState;
        }

        // state.idDealer = decodedToken.MobileAssistanceUserId;
        // state.idCompany = decodedToken.MobileAssistanceIdCompany;
        // state.isMainDealer = decodedToken.MobileAssistanceFlMainDealer;
        state.isAuthenticated = true;
        state.user = decodedToken;
        state.token = accessToken;
        state.company = decodedToken.MobileAssistanceIdCompany;
      } catch (error) {
        setSession(null);
        return initialState;
      }
    },
    clearAuthData: () => {
      setSession(null);
      return initialState;
    },
    initializeAuth: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.company = action.payload.company;
      state.idDealer = action.payload.idDealer;
      state.isMainDealer = action.payload.isMainDealer;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase('AUTH_REQUEST', (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase('AUTH_SUCCESS', (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase('AUTH_FAILURE', (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setAuthData, clearAuthData, initializeAuth } = authSlice.actions;

// Memoized base selector
const selectAuthState = (state) => state.auth;

// Memoized derived selectors
export const selectAuth = createSelector(
  [selectAuthState],
  (auth) => ({
    // idDealer: auth.idDealer,
    // idCompany: auth.idCompany,
    isAuthenticated: auth.isAuthenticated,
    isMainDealer: auth.isMainDealer,
    user: auth.user,
    token: auth.token,
    company: auth.company
  })
);

export const selectIsAuthenticated = createSelector(
  [selectAuthState],
  (auth) => auth.isAuthenticated
);

export const selectAuthLoading = createSelector(
  [selectAuthState],
  (auth) => auth.loading
);

export const selectAuthError = createSelector(
  [selectAuthState],
  (auth) => auth.error
);

export const selectUser = createSelector(
  [selectAuthState],
  (auth) => auth.user
);

export const selectToken = createSelector(
  [selectAuthState],
  (auth) => auth.token
);

export const selectCompany = createSelector(
  [selectAuthState],
  (auth) => auth.company
);

export const selectDealer = createSelector(
  [selectAuthState],
  (auth) => auth.idDealer
);

export const selectIsMainDealer = createSelector(
  [selectAuthState],
  (auth) => auth.isMainDealer
);

export default authSlice.reducer; 